_ = require 'underscore'

idToDateMap = {
  # Package Tracker
  '55a5d917446f51777421000d': "2016-08-07"
  # Card Fields
  '56d5e249a98895a9797bebb9': "2016-08-23"
  # Screenful
  '570262ea1100fa611d7e200a': "2016-08-23"
  # Intercom
  '56cdf5f7071f133a93eb2363': "2016-08-23"
  # Card Repeater
  '57b47fb862d25a30298459b1': "2016-08-23"
}

module.exports = _.chain(idToDateMap)
  .pairs()
  .map(([key, value]) -> [key, new Date(Date.parse(value))])
  .object()
  .value()



// WEBPACK FOOTER //
// ./app/scripts/data/new-power-ups.coffee